import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type BooleanField = Extract<MaintenanceChecklistField, { type: 'boolean' }>;

type Props = {
  field: BooleanField;
  readOnly?: boolean;
};

export function ChecklistBooleanField({ field, readOnly = true }: Props) {
  return (
    <ChecklistFieldShell field={field}>
      <Input type="checkbox" disabled={readOnly} className="w-auto" />
    </ChecklistFieldShell>
  );
}
